import React from "react";
import clsx from "clsx";
import { isEmpty } from "lodash";
import { Box, Typography, Button, Grid } from "@material-ui/core";

// direct import
import "../style.scss";
import { MyCheckboxRenewal } from "../checkbox";
import { Fonts } from "theme/fontConfig";

const Household = ({ data, selectedValue, setValue }) => {
  const isSelected = (option) => selectedValue?.includes(option) ?? false;

  const handleCheck = (e, interest) => {
    if (e.target.checked) {
      if (!selectedValue.includes(interest)) {
        setValue("houseOptions", [...selectedValue, interest]);
      }
    } else {
      setValue(
        "houseOptions",
        selectedValue.filter((el) => el !== interest)
      );
    }
  };

  return (
    <Box className="summary-renewal__card">
      <Typography className="summary-renewal__title">
        Household Interests
      </Typography>
      <Grid container spacing={2}>
        {[...(data ?? [])].sort((a, b) => a.localeCompare(b)).map((interest, index) => {
          const selected = isSelected(interest);
          return (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Button
                fullWidth
                variant="outlined"
                style={{
                  height: 49,
                }}
                className={clsx(
                  "summary-renewal__option-button",
                  selected && "selected"
                )}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  width="100%"
                >
                  <MyCheckboxRenewal
                    id={`houseOption-${index}`}
                    color="primary"
                    checked={selected}
                    onChange={(e) => handleCheck(e, interest)}
                    style={{ margin: 0 }}
                    name="houseOptions"
                  />

                  <Typography
                    style={{
                      fontSize: Fonts.GeneralXLargeBodyFont.fontSize,
                      fontWeight: Fonts.GeneralXLargeBodyFont.fontWeight,
                      marginLeft: 10,
                      color: selected ? "#155eef" : "rgb(65 73 84)",
                    }}
                  >
                    {interest}
                  </Typography>
                </Box>
              </Button>
            </Grid>
          );
        })}
        {isEmpty(data) && (
          <Box
            sx={{
              flexDirection: "column",
              height: 100,
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Typography variant="h6">No data available.</Typography>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default Household;
